import { FC, memo, ReactNode } from 'react';

interface ITcPageTitle {
  title?: ReactNode;
  moreContent?: ReactNode;
  icon?: any;
  descriptions?: ReactNode;
}

const TcPageTitle: FC<ITcPageTitle> = ({ title, moreContent, icon, descriptions }) => {
  return (
    <>
      <div className='flex flex-col items-center justify-between gap-4 px-6 py-4 mb-2 font-bold border rounded-lg sm:flex-row bg-t-bg-color border-t-border-color-base'>
        <div>
          <div className='flex items-center justify-center gap-1 sm:justify-start'>
            {icon} {title}
          </div>
          {descriptions}
        </div>
        {moreContent}
      </div>
    </>
  );
};

export default memo(TcPageTitle);
